import { createRoot } from 'react-dom/client';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { datadogRum } from '@datadog/browser-rum';

// project imports
import App from 'App';
import { BASE_PATH } from 'config';
import { store } from 'store';
import * as serviceWorker from 'serviceWorker';
import reportWebVitals from 'reportWebVitals';
import { ConfigProvider } from 'contexts/ConfigContext';
import { configApi } from './config';
import { suppressBenignRuntimeErrors } from 'utils/suppressBenignRuntimeErrors';

// style + assets
import 'assets/scss/style.scss';

// Evita el overlay de webpack por ResizeObserver al redimensionar firmas en el visor PDF.
suppressBenignRuntimeErrors();
// Initialize Datadog RUM
if (configApi.env === 'production') {
    datadogRum.init({
        applicationId: `${configApi.datadog.applicationId}`,
        clientToken: `${configApi.datadog.clientToken}`,
        site: 'datadoghq.eu',
        service: 'rubricae-dashboard',
        allowedTracingUrls: [
            `${configApi.rubricae.url}`,
            `${configApi.certifier.url}`,
            `${configApi.otps.url}`,
            (url) => url.startsWith(`${configApi.rubricae.url}`),
            (url) => url.startsWith(`${configApi.certifier.url}`),
            (url) => url.startsWith(`${configApi.otps.url}`)
        ],
        env: configApi.env as string,
        //  version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input'
    });
}

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
    <Provider store={store}>
        <ConfigProvider>
            <BrowserRouter basename={BASE_PATH}>
                <App />
            </BrowserRouter>
        </ConfigProvider>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
